import React from "react";

const NotificationBanner: React.FC<{
    message: string;
    subMessage?: string;
    onClick?: () => void;
}> = ({ message, subMessage, onClick }) => (
    <div
        style={{
            padding: 15,
            borderRadius: 10,
            backgroundColor: "#eee",
            color: "#eb304f",
            border: "solid 2px pink",
            fontSize: "1.2rem",
            cursor: "pointer",
        }}
        onClick={onClick}
    >
        <b>{message}</b>
        {subMessage && (
            <div style={{ marginTop: "5px", fontSize: "1.1rem" }}>
                <span>{subMessage}</span>
            </div>
        )}
    </div>
);

export default NotificationBanner;